import {
  logEvent,
  setUserId,
  setUserProperties,
  type Analytics,
} from 'firebase/analytics';
import type { AnalyticsParams, AnalyticsTracker } from './types';
import { initFirebaseAnalytics, getFirebaseAnalytics } from './firebase';

export const createFirebaseAnalyticsTracker = (): AnalyticsTracker => {
  const withAnalytics = (fn: (a: Analytics) => void): void => {
    const a = getFirebaseAnalytics();
    if (a) fn(a);
  };

  return {
    bootstrap() {
      void initFirebaseAnalytics();
    },

    track(eventName: string, params?: AnalyticsParams) {
      withAnalytics((a) => {
        logEvent(a, eventName, params as Record<string, unknown>);
      });
    },

    setUserId(userId: string | null) {
      withAnalytics((a) => {
        setUserId(a, userId);
      });
    },

    setUserProperties(properties: AnalyticsParams) {
      withAnalytics((a) => {
        setUserProperties(a, properties as Record<string, string>);
      });
    },
  };
};
